module.exports = __webpack_public_path__ + "static/media/subscribe@3x.712f21df.png";